// eslint-disable-next-line simple-import-sort/imports
import React from 'react';
import { createRoot } from 'react-dom/client';

import 'antd/dist/antd.min.css';

import { ConfigProvider, Empty } from 'antd';
import { Provider } from 'react-redux';
import { Router } from './app/router';
import store from './app/store';

import 'styles/global/main.scss';

createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <ConfigProvider renderEmpty={() => <Empty description="No Data" />}>
      <Router />
    </ConfigProvider>
  </Provider>,
);
